import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'

export interface DialogCategoryPromotionAnnouncementProps {
  title: string
  description?: string
  open: boolean
  onClose: () => void
}

export const DialogCategoryPromotionAnnouncement = (props: DialogCategoryPromotionAnnouncementProps) => {
  const { open, onClose, title, description } = props

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxHeight={328}>
      <DialogHeader>{title}</DialogHeader>
      <DialogContent minHeight={276}>
        <Text color={colors.grey800}>
          <pre>
            {description}
          </pre>
        </Text>
      </DialogContent>
    </Dialog>
  )
}
